const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWoundsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.388 24a1.185 1.185 0 0 1-.844-.35L.35 18.453a1.2 1.2 0 0 1 0-1.688L5.116 12 .35 7.235a1.2 1.2 0 0 1 0-1.688L5.545.35A1.193 1.193 0 0 1 6.382 0a1.233 1.233 0 0 1 .85.35l4.763 4.768L16.758.35a1.193 1.193 0 0 1 1.687 0l5.194 5.2a1.2 1.2 0 0 1 0 1.688L18.877 12l4.775 4.765a1.193 1.193 0 0 1 0 1.688l-5.194 5.2a1.234 1.234 0 0 1-.85.348 1.178 1.178 0 0 1-.85-.348l-4.763-4.765-4.763 4.762a1.185 1.185 0 0 1-.844.35zm11.2-10.719-4.338 4.346 4.343 4.334 4.333-4.346zm-5.577-.108a1.2 1.2 0 1 0 1.2 1.194 1.2 1.2 0 0 0-1.2-1.194zm2.4-2.4a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zm-4.787 0a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zm2.393-2.391a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zM6.382 2.05 2.038 6.4l4.344 4.334 4.333-4.346z",
    transform: "translate(-.002)",
    style: {
      fill: "#002d72"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoundsIcon);
export default __webpack_public_path__ + "static/media/wounds-icon.a982903feffb3a8ce0126431aab15cbd.svg";
export { ForwardRef as ReactComponent };